import { CtaButton } from '@tkww/orion-web-ds-action';
import { useAtom } from 'jotai';
import React, { type Dispatch, type FC, type SetStateAction } from 'react';
import { appliedFiltersCountAtom } from '../../FilterPills/atoms';
import { useClearedSearch } from '../hooks/use-cleared-search';
import type { TrackMapView } from '../hooks/use-track-map-view';
import Styles from './clear-filters-button.scss';

interface ClearFiltersButtonProps {
	isCleared: boolean;
	setFilteredVendors: Dispatch<SetStateAction<Vendor.Raw[]>>;
	setIsCleared: Dispatch<SetStateAction<boolean>>;
	trackMapView: TrackMapView;
}

const ClearFiltersButton: FC<ClearFiltersButtonProps> = (props) => {
	const { isCleared, setFilteredVendors, setIsCleared, trackMapView } = props;
	const clearedSearch = useClearedSearch(setFilteredVendors);
	const [appliedFiltersCount] = useAtom(appliedFiltersCountAtom);

	const isZeroFilters = isCleared || appliedFiltersCount === 0;

	if (isZeroFilters) {
		return null;
	}

	const clearFilters = () => {
		trackMapView('clear-filters-click');
		setIsCleared(true);
		clearedSearch();
	};

	return (
		<CtaButton
			styleType="secondary-alternative"
			size="sm"
			className={Styles.btn}
			onClick={clearFilters}
		>
			Clear filters {`(${appliedFiltersCount})`}
		</CtaButton>
	);
};

export { ClearFiltersButton };
